import { render, staticRenderFns } from "./partyBuildingActivities.vue?vue&type=template&id=639bc018&scoped=true&"
import script from "./partyBuildingActivities.vue?vue&type=script&lang=js&"
export * from "./partyBuildingActivities.vue?vue&type=script&lang=js&"
import style0 from "./partyBuildingActivities.vue?vue&type=style&index=0&id=639bc018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639bc018",
  null
  
)

export default component.exports